import { render, staticRenderFns } from "./TheAggregatedViewTotals.vue?vue&type=template&id=0f16d768&scoped=true"
import script from "./TheAggregatedViewTotals.vue?vue&type=script&lang=js"
export * from "./TheAggregatedViewTotals.vue?vue&type=script&lang=js"
import style0 from "./TheAggregatedViewTotals.vue?vue&type=style&index=0&id=0f16d768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f16d768",
  null
  
)

export default component.exports